import React from 'react'
import ProductDetail121 from './ProductDetail121'
import ProductDetail122 from './ProductDetail122'
// import ProductDetail123 from './ProductDetail123'
import ProductDetail124 from './ProductDetail124'
import ProductDetail125 from './ProductDetail125'
import ProductDetail126 from './ProductDetail126'
import ProductDetail127 from './ProductDetail127'
import ProductDetail128 from './ProductDetail128'
import ProductDetail129 from './ProductDetail129'
import ProductDetail130 from './ProductDetail130'
import ProductDetail131 from './ProductDetail131'
import ProductDetail132 from './ProductDetail132'
import ProductDetail133 from './ProductDetail133'
import Gfooter from '../Component/Gfooter'

function ProductDetail12() {
  return (
    <>
    <ProductDetail121/>
    <ProductDetail122/>
    {/* <ProductDetail123/> */}
    
    <ProductDetail124/>
    <ProductDetail125/>
    <ProductDetail126/>
    {/* <ProductDetail127/> */}
    <ProductDetail128/>
     <ProductDetail127/>
     {/* <ProductDetail129/> */}
     <ProductDetail130/>
     <ProductDetail131/>
     <ProductDetail132/>
     <ProductDetail133/>
     <Gfooter/>
    </>
  )
}

export default ProductDetail12
